import React from "react";

import ZydusLogo from "../../../assets/images/logos/zydus-logo.svg";
import GoodFlipLogo from "../../../assets/images/logos/goodflip-care-logo.svg";

interface PoweredByLogoProps {
  supportProgramKey: string;
  imageUrl?: string;
}

const PoweredByLogo: React.FC<PoweredByLogoProps> = ({
  supportProgramKey,
  imageUrl,
}) => {
  return (
    <div className="h-full flex-1 flex flex-col items-center justify-end">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`Powered by ${supportProgramKey}`}
          className="h-[54px]"
        />
      ) : (
        <div className="text-center pb-4 flex items-center justify-center gap-2">
          <div className="flex flex-row items-center justify-center gap-1.5">
            <div className="text-xs text-gray-600 font-thin">
              An initiative by
            </div>
            <img
              src={ZydusLogo}
              alt={`Powered by ${supportProgramKey}`}
              className="w-14 mb-0.5"
            />
          </div>

          <div className="w-px h-4 bg-gray-400"></div>

          <div className="flex flex-row items-center justify-center gap-1.5">
            <div className="text-xs text-gray-600 font-thin">Powered by</div>
            <img
              src={GoodFlipLogo}
              alt={`Powered by ${supportProgramKey}`}
              className="w-20 mt-1"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PoweredByLogo;
